module.exports = __webpack_public_path__ + "static/media/LakeSprite.43841c54.png";